import React, { useEffect, useRef, useState} from "react";
import {
    ListContentWrap,
    PageArticleWrap,
    PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import {ListResult, SingleResult, SiteInfo, SitePostType, UserInfo, UserSiteInfo} from "../../type/type";
import Loading from "components/Loading";
import {getImageUrl, getSiteOne, getUser, updateSiteHandler} from "../../api/api";
import {OutlinePrimaryBtn, SolidPrimaryBtn, SolidPrimarySubBtn } from "components/button/Button";
import styled from "styled-components";
import {aesCBCDecrypt, checkTelephone, getByteSize, handleImageUpload, ROLE_DIRECTOR} from "../../utils/commonUtils";
import {DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType} from "components/ModalComponent";
import {useDaumPostcodePopup} from "react-daum-postcode";
import {themeObj} from "pages/login/Register";
import { InputWrapC, InputWrapR } from "components/common/CommonLayout";
import { colors } from "styles/global-styles";
import { useRecoilValue } from "recoil";
import { selectSiteIdState, userRoleState } from "styles/atoms";

const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    line-height: 1.25;
`
const InputSubRow = styled.div`
    display: flex;
    gap: 1rem;
    flex-direction: column;
    width: 50%;
`
const AddressWrap = styled.div`
    position: relative;

    input {
        width: 100%;
    }
    .search-icon {
        position: absolute;
        right: 1rem;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    &:hover {
        cursor: pointer;
    }
`
const MainImageWrap = styled.div`
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    aspect-ratio: 1 / 1;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: left;
    }
`;


export const SiteInformation = () => {
    // 전역 데이터
    const user_role = useRecoilValue(userRoleState);
    const selectSiteId = useRecoilValue(selectSiteIdState);

    const fileInput = useRef<HTMLInputElement>(null);

    const [loading, setLoading] = useState<boolean>(false);
    //대표자 이름
    const [directorUserName, setDirectorUserName] = useState<string>("");
    // 대표 이미지/사이즈
    const [siteImage, setSiteImage] = useState("");
    const [, setImageSize] = useState("");

    //정보
    const [site, setSite] = useState<SiteInfo>({
        id: 0,
        name: "",
        phone: "",
        approval: 0,
        latitude: 0,
        longitude: 0,
        company_id: 0,
        road_address: "",
        jibun_address: "",
        detail_address: "",
        road_name: "",
        road_building_number: "",
        jibun_building_number: "",
        zip_code: "",
        temp_phone: "",
        reg_date: "",
        update_date: "",
        approval_date: "",
        image_list: [],
        type: 0,
        sido: "",
        sigungu: "",
        eupmyeondong: "",
        ri: "",
        fax: "",
        email: "",
        domain_comment:"",
        full_domain:"", //풀 도메인
        main_domain:"", //메인 도메인
        sub_domain:"", //서브 도메인
        server_port:0, //서버 포트
        is_ddns:0, //ddns 등록 상태 0:미등록, 1:등록
        update_cycle_minute: 0, //업데이트 주기 (분)
        check_in_start_time: "",
        check_in_end_time: "",
        check_out_start_time: "",
        check_out_end_time: "",
        holiday_check_in_start_time: "",
        holiday_check_in_end_time: "",
        holiday_check_out_start_time: "",
        holiday_check_out_end_time: "",
    });
    //정보 수정 시 필요한 정보
    const [requestSite, setRequestSite] = useState<SitePostType>({
        name: "",
        full_address: "",
        detail_address: "",
        phone: "",
        fax: "",
        email: "",
        temp_phone: "",
        approval: 0,
        base64_list: [],
        check_in_start_time: "",
        check_in_end_time: "",
        check_out_start_time: "",
        check_out_end_time: "",
        holiday_check_in_start_time: "",
        holiday_check_in_end_time: "",
        holiday_check_out_start_time: "",
        holiday_check_out_end_time: "",
    });

    const [modalProps, setModalProps] = useState<ModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        button: null,
        type: ""
    });

    async function getSite(){
        try {
            const res: SingleResult<SiteInfo> = await getSiteOne();

            if (res.code === 200) {
                setSite(res.data);

                // 이미지 저장
                let imageUrl = '';
                if (res.data.image_list && res.data.image_list.length) {
                    imageUrl = getImageUrl(res.data.image_list[0].file_name);
                }

                setSiteImage(imageUrl);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    //대표자 이름 가져오기
    async function getUserList(){
        try{
            const res: ListResult<UserInfo> = await getUser({ site_id: selectSiteId });
            const userList:UserInfo[] = res.data;
            userList.forEach((user: UserInfo) => {
                user.user_site_list.forEach((userSiteInfo:UserSiteInfo) => {
                    if(user.role === ROLE_DIRECTOR && userSiteInfo.site_id === selectSiteId){
                        setDirectorUserName(aesCBCDecrypt(user.name));
                    }
                });
            });
        }
        catch (error) {
            console.error(error);
        }
    }

    //정보 수정 모달 열기
    function openModal(modalType: ModalType) {
        let title: ModalTitle = "학교 정보 수정";
        let content: JSX.Element = <></>;
        let button: JSX.Element = <></>;

        setModalProps({
            isOpen: true,
            isClose: () => setModalProps({...modalProps, isOpen: false}),
            title: title,
            content: content,
            button: button,
            type: modalType
        });
    }

    //정보 수정 버튼
    function ButtonContent(): JSX.Element {

        //정보 수정
        async function updateSite():Promise<void>{
            try {

                //연락처 - site 대표 번호 또는 핸드폰 번호로 설정할 수 있음
                if (!requestSite.name || !requestSite.phone || !requestSite.full_address) {
                    alert('필수 입력값을 다 입력해주세요.');
                    return;
                }
                if (requestSite.phone && !checkTelephone(requestSite.phone)) {
                    alert('정확한 연락처를 입력해주세요.');
                    return;
                }

                if (requestSite.temp_phone && !checkTelephone(requestSite.temp_phone)) {
                    alert('긴급 연락처를 다시 입력해주세요.');
                    return;
                }

                const response = await updateSiteHandler(requestSite);
                if(response.code === 200){
                    alert("학교 정보가 수정되었습니다.");
                    setModalProps({...modalProps, isOpen: false});
                }
                else{
                    alert("학교 정보 수정에 실패하였습니다.");
                }

            }
            catch (err) {
                console.error(err);
            }
            finally {
                getSite();
            }
        }

        return (
            <SolidPrimaryBtn onClick={updateSite} className="default-bottom-btn" disabled={!requestSite.name || !requestSite.phone || !requestSite.full_address}>
                저장
            </SolidPrimaryBtn>
        )
    }

    //정보 수정 모달 content
    function ModalContent(): JSX.Element {

        // 파일 선택 - input 클릭 시(사진)
        const handleButtonClick = (e: any) => {
            fileInput.current?.click();
        };

        //이미지 파일 변경 이벤트
        const onImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
            const base64Files: string[] | undefined = await handleImageUpload(event);
            if (base64Files && base64Files.length > 0) {
                setBase64Image(base64Files[0]);
            }
            if (event.target.files && event.target.files.length) {
                const imageSize = getByteSize([event.target.files[0].size]) || "";
                setImageSize(imageSize);
            }
        };

        const setBase64Image = (base64: string) => {
            //이미지는 1개만 등록할수 있게, 배열 초기화 후 추가
            setRequestSite({
                ...requestSite,
                base64_list: [...[], base64]
            });
        };
            
        //정보 수정 input 값 변경
        function changeRequestSite(e: React.ChangeEvent<HTMLInputElement>):void {
            const {name, value} = e.target;
            setRequestSite({
                ...requestSite,
                //phone, temp_phone 입력 시 하이픈 제거
                [name]: name === "phone" || name === "temp_phone" ? value.replace(/[^0-9]/g, '') : value
            });
        }

        return (
            <InputWrapC>
                <InputWrapC>
                    <label className="required_value">학교명 </label>
                    <input type="text" name="name" placeholder="학교명 입력" onChange={changeRequestSite} value={requestSite.name} />
                </InputWrapC>
                <InputWrapR $alignItems="center">
                    <InputWrapC>
                        <label className="required_value">연락처 ('-'없이 숫자만)</label>
                        <input type="text" name="phone" placeholder="연락처 입력('-'없이 숫자만)" onChange={changeRequestSite} value={requestSite.phone ? requestSite.phone.replace(/[^0-9]/g, '') : ''} />
                    </InputWrapC>
                    <InputWrapC>
                        <label>긴급 연락처 ('-'없이 숫자만)</label>
                        <input type="text" name="temp_phone" placeholder="긴급 연락처 입력('-'없이 숫자만)" onChange={changeRequestSite} value={requestSite.temp_phone ? requestSite.temp_phone.replace(/[^0-9]/g, '') : ''} />
                    </InputWrapC>
                </InputWrapR>
                <InputWrapC>
                    <label className="required_value">주소</label>
                    <AddressWrap onClick={searchSite}>
                        <input type="text" name="full_address" readOnly placeholder="주소 입력" onChange={changeRequestSite} value={requestSite.full_address} />
                        <img className="search-icon" src="/image/icon/search.svg" alt="search"/>
                    </AddressWrap>
                </InputWrapC>
                <InputWrapC>
                    <label>상세 주소</label>
                    <input type="text" name="detail_address" placeholder="상세 주소 입력" onChange={changeRequestSite} value={requestSite.detail_address} />
                </InputWrapC>
                <InputWrapC>
                    <InputWrapR $alignItems="center" $justifyContent="space-between">
                        <label>대표 이미지</label>
                        <div onClick={handleButtonClick}>
                            <OutlinePrimaryBtn type="button">사진 등록</OutlinePrimaryBtn>
                            <input
                                type="file"
                                name="file"
                                onChange={(e) => onImageChange(e)}
                                accept=".jpg, .png, .jpeg, .JFIF" 
                                style={{ display: "none" }}
                                ref={fileInput}
                                />
                        </div>
                    </InputWrapR>
                    <InputWrapR>
                        { requestSite.base64_list && requestSite.base64_list.length > 0 ?
                            <MainImageWrap>
                                <img className="preview-image" srcSet={requestSite.base64_list[0]} alt="main_image" />
                            </MainImageWrap>
                            :
                            siteImage ?
                            <MainImageWrap>
                                <img className="preview-image" srcSet={siteImage} alt="main_image" />
                            </MainImageWrap>
                            :
                            null
                        }
                    </InputWrapR>
                </InputWrapC>
            </InputWrapC>
        )
    }

    // 주소 검색
    const open = useDaumPostcodePopup();
    // 주소 검색 후 주소 값 변경
    function openDaumPostcode(data: any):void {
        setRequestSite(prev => ({
            ...prev,
            full_address: data.roadAddress
        }));
    }
    // 주소 검색 모달 열기
    function searchSite():void {
        open({ onComplete: openDaumPostcode, theme: themeObj });
    }

    //학교 수정 클릭 시 requestSite 값 갱신
    function setRequestSiteValue() {

        setRequestSite({
            name: site.name,
            full_address: site.road_address,
            detail_address: site.detail_address,
            phone: site.phone,
            fax: site.fax,
            email: site.email,
            temp_phone: site.temp_phone,
            approval: site.approval,
            base64_list: [],
            check_in_start_time: site.check_in_start_time,
            check_in_end_time: site.check_in_end_time,
            check_out_start_time: site.check_out_start_time,
            check_out_end_time: site.check_out_end_time,
            holiday_check_in_start_time: site.holiday_check_in_start_time,
            holiday_check_in_end_time: site.holiday_check_in_end_time,
            holiday_check_out_start_time: site.holiday_check_out_start_time,
            holiday_check_out_end_time: site.holiday_check_out_end_time,
        });
    }

    useEffect(() => {
        setLoading(true);
        getSite();
        getUserList();
    }, []);

    return (
        loading ? (
            <Loading />
        ) : (
            <>
                <PageHeaderTitleButtonStyle>
                    <p className="header-title">학교 정보</p>
                </PageHeaderTitleButtonStyle>

                <PageArticleWrap>
                    <article className="list-content-container" style={{gap: '1.5rem',overflow:'auto'}}>
                        <div className="article-header height-auto">
                            <p>
                                <span className="article-header-title">학교 기본 정보</span>
                            </p>
                            {user_role === ROLE_DIRECTOR &&
                                <SolidPrimarySubBtn onClick={() => { openModal("siteModify"); setRequestSiteValue(); }} type="button">
                                    수정
                                </SolidPrimarySubBtn>
                            }
                        </div>
                        <ListContentWrap style={{height: 'auto', width: '50%'}}>
                            <InputContainer>
                                <InputWrapC>
                                    <label>학교명</label>
                                    <input type="text" name="name" value={site.name} readOnly/>
                                </InputWrapC>

                                <InputWrapC>
                                    <label>대표자명</label>
                                    <input type="text" name="name" value={directorUserName} readOnly/>
                                </InputWrapC>
                                <InputWrapR>
                                    <InputSubRow>
                                        <label>연락처</label>
                                        <input type="text" name="name" value={site.phone} readOnly/>
                                    </InputSubRow>
                                    <InputSubRow>
                                        <label>긴급 연락처</label>
                                        <input type="text" name="name" value={site.temp_phone} readOnly/>
                                    </InputSubRow>
                                </InputWrapR>
                                <InputWrapC>
                                    <label>주소</label>
                                    <input type="text" name="name" value={site.road_address + " " + site.detail_address} readOnly/>
                                </InputWrapC>
                                <InputWrapC>
                                    <span>대표 이미지</span>
                                    {siteImage ?
                                        <MainImageWrap>
                                            <img className="preview-image" srcSet={siteImage} alt="main_image"/>
                                        </MainImageWrap>
                                        :
                                        <div style={{color: colors.textFieldDisabledText}}>등록된 대표 이미지가 없습니다.</div>
                                    }
                                </InputWrapC>

                            </InputContainer>
                        </ListContentWrap>

                    </article>
                </PageArticleWrap>


                <DefaultModalComponent isOpen={modalProps.isOpen}
                                       content={ModalContent()}
                                       button={ButtonContent()}
                                       type={modalProps.type}
                                       isClose={modalProps.isClose}
                                       title={modalProps.title}/>
            </>
        )
    );
}